<!-- eslint-disable vue/no-v-html -->
<template>
  <section v-if="productAnnouncement" class="bg-blue-400/10 py-12">
    <div class="container-wrap desktop:flex">
      <div class="desktop:w-4/12">
        <p class="text-sm font-bold text-gray-600">
          {{ tGlobal('products.section-name.announcement') }}
        </p>
        <h2 class="text-h2 mb-6">
          {{ productAnnouncement.sectionTitle }}
        </h2>
      </div>
      <div class="overflow-hidden desktop:w-8/12">
        <div
          class="markdown-content"
          v-html="
            provideMarkdownHtml(productAnnouncement.description, 'simple')
          "
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t: tGlobal } = useI18n({ useScope: 'global' });

  const productsStore = useProductsStore();
  const { productAnnouncement } = storeToRefs(productsStore);
</script>
